module.exports = __webpack_public_path__ + "static/media/RememberDroppedSequence.daf93c0d.jpg";